module.exports = __webpack_public_path__ + "static/media/7.773abb58.svg";